import { ReactNode, useMemo } from "react";

import { useSignalR } from "../Hooks/useSignalR";
import SignalRContext, { SignalRContextType } from "../Contexts/SignalRContext";
import { resolveIsInitialConnectPending } from "../../utilities/helpers/connectionStatus";

interface SignalRProviderProps {
	hubUrl: string;
	children: ReactNode;
}

export const SignalRProvider: React.FC<SignalRProviderProps> = ({ hubUrl, children }) => {
	const { connection, isConnecting, isReconnecting, error, hasCompletedInitialConnect } = useSignalR(hubUrl);
	const isConnectionLoading = resolveIsInitialConnectPending({ isConnecting, hasCompletedInitialConnect });

	const value: SignalRContextType = useMemo(
		() => ({ connection, isConnectionLoading, isReconnecting, connectionError: error }),
		[connection, isConnectionLoading, isReconnecting, error]
	);

	return <SignalRContext.Provider value={value}>{children}</SignalRContext.Provider>;
};